import { OperatorState } from "../model/OperatorState";

export interface IOperatorService {
  persistedState?: OperatorState;
  saveOperatorState(newState: OperatorState): void;
  clearOperatorState(): void;
}

export const OperatorService = Symbol.for("OperatorService");
